import React from "react";
import {
  FilterDatePickerBase,
  FormDatePickerBase,
  FilterDatePickerProps,
  FormDatePickerProps,
} from "./DatePickerBase";

interface RangeStartDatePickerProps {
  rangeEnd: moment.Moment;
}

export const FormRangeStartDatePicker = ({ rangeEnd, ...rest }: RangeStartDatePickerProps & FormDatePickerProps) =>
  <FormDatePickerBase
    mode="rangeStart"
    rangeValue={rangeEnd}
    {...rest}
  />

export const FilterRangeStartDatePicker = ({ rangeEnd, ...rest }: RangeStartDatePickerProps & FilterDatePickerProps) =>
  <FilterDatePickerBase
    mode="rangeStart"
    rangeValue={rangeEnd}
    {...rest}
  />

interface RangeEndDatePickerProps {
  rangeStart: moment.Moment;
}

export const FormRangeEndDatePicker = ({ rangeStart, ...rest }: RangeEndDatePickerProps & FormDatePickerProps) =>
  <FormDatePickerBase
    mode="rangeEnd"
    rangeValue={rangeStart}
    {...rest}
  />

export const FilterRangeEndDatePicker = ({ rangeStart, ...rest }: RangeEndDatePickerProps & FilterDatePickerProps) =>
  <FilterDatePickerBase
    mode="rangeEnd"
    rangeValue={rangeStart}
    {...rest}
  />
